import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';
import { firebaseApp } from '../index';
import { ICommissionResponse, ISale, ISrikandiUser, ISummarySale, IUser, SrikandiSale, ReinstatementRetention, TotalSale, SalesSrikandi, TopSaleSrikandi, NewSrikandi, Recruit } from '../@types';
import { useEffect, useState } from 'react';
import { get, getDatabase, onValue, ref } from 'firebase/database';
import { CommissionRow } from '../Pages/Commission/Settings/CSVImporter';
import { OverrideCommissionRow } from '../Pages/Commission/Settings/CSVImporterOverrideCommission';
import { RemovetagRow } from '../Pages/Commission/Settings/CSVImporterRemoveShopifyTag';
import { XilnexCommissionRow } from '../Pages/Commission/Settings/CSVImprterXilnexCommission';
import { AddtagRow } from '../Pages/Commission/Settings/CSVImporterAddShopifyTag';
import { erpConfig } from '../config/erp';

const useEmulator = process.env.NODE_ENV === 'development';

export const submitCustomCommission = async (rows: CommissionRow[], date: string) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const submitCustomCommission = httpsCallable(functions, 'mutation-submitCustomCommission');
  const { data } = await submitCustomCommission({ rows, date });
  return data;
};
export const submitOverrideCommision = async (rows: OverrideCommissionRow[], date: string) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const submitOverrideCommision = httpsCallable(functions, 'mutation-submitOverrideCommision');
  const { data } = await submitOverrideCommision({ rows, date });
  return data;
};

export const submitDataSrikandiRemoveTag = async (rows: RemovetagRow[]) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const submitDataSrikandiRemoveTag = httpsCallable(functions, 'mutation-removeShopifySrikandiTag');
  const { data } = await submitDataSrikandiRemoveTag({ rows });
  return data;
};
export const addShopifySrikandiTag = async (rows: AddtagRow[]) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const addShopifySrikandiTag = httpsCallable(functions, 'mutation-addShopifySrikandiTag');
  const { data } = await addShopifySrikandiTag({ rows });
  return data;
};
export const submitDataCommissionXilnex = async (rows: XilnexCommissionRow[], date: any) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const submitDataCommissionXilnex = httpsCallable(
    functions,
    'mutation-submitDataCommissionXilnex',
  );
  const { data } = await submitDataCommissionXilnex({ rows, date });
  return data;
};

export const assignCoupon = async (srikandiId: string, coupon?: string) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const assignCoupon = httpsCallable(functions, 'mutation-assignSrikandi');
  const { data } = await assignCoupon({ srikandiId, coupon });
  return data;
};

export const updateDeactivateSrikandiTag = async (srikandiId: string) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const updateDeactivateSrikandiTag = httpsCallable(
    functions,
    'mutation-updateDeactivateSrikandiTag',
  );
  const { data } = await updateDeactivateSrikandiTag({ srikandiId });
  return data;
};

export const getSrikandiChildren = async (srikandiId: string) => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getSrikandiChildren = httpsCallable(functions, 'query-getSrikandiChildren');
  const { data } = await getSrikandiChildren({ srikandiId });
  return data as any[];
};

export const getSales = async (id: string, from: string, till: string): Promise<ISale[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getSales = httpsCallable(functions, 'query-sales');
  console.log(id, from, till);
  const { data } = await getSales({ id, from, till });
  return data as any;
};

export const allSales = async (from: string, till: string): Promise<ISale[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const allSales = httpsCallable(functions, 'query-allSales');
  // console.log(id, from, till);
  const { data } = await allSales({ from, till });
  return data as ISale[];
};

export const totalSales = async (from: string, till: string): Promise<TotalSale[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const totalSales = httpsCallable(functions, 'query-totalSales');
  console.log(from, till);
  const { data } = await totalSales({ from, till });
  return data as TotalSale[];
};

export const topSales = async (from: string, till: string): Promise<TopSaleSrikandi> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const topSales = httpsCallable(functions, 'query-topSales');
  const { data } = await topSales({ from, till });
  return data as TopSaleSrikandi;
};

export const srikandiAllSales = async (from: string, till: string): Promise<SalesSrikandi> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const srikandiAllSales = httpsCallable(functions, 'query-srikandiAllSales');
  console.log(from, till);
  const { data } = await srikandiAllSales({ from, till });
  return data as SalesSrikandi;
};

export const getNewSrikandi = async (from: string, till: string): Promise<NewSrikandi[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getNewSrikandi = httpsCallable(functions, 'query-getNewSrikandi');
  const { data } = await getNewSrikandi({ from, till });
  return data as NewSrikandi[];
};

export const getRecruit = async (from: string, till: string): Promise<Recruit[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getRecruit = httpsCallable(functions, 'query-getRecruit');
  const { data } = await getRecruit({ from, till });
  return data as Recruit[];
};

export const srikandiReinstateRetention = async (): Promise<ReinstatementRetention> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const srikandiReinstateRetention = httpsCallable(functions, 'query-srikandiReinstateRetention');
  const { data } = await srikandiReinstateRetention({});
  return data as ReinstatementRetention;
};

export const getSrikandiEmas = async (): Promise<ISrikandiUser[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getSrikandiEmas = httpsCallable(functions, 'query-getSrikandiEmas');
  const { data } = await getSrikandiEmas();
  return data as any;
};

export const getSrikandiSales = async (
  id: string,
  from: string,
  till: string,
): Promise<ISale[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getSrikandiSales = httpsCallable(functions, 'query-srikandiSales');
  console.log(id, from, till);
  const { data } = await getSrikandiSales({ id, from, till });
  return data as any;
};

export const getSrikandiChildrenSales = async (
  id: string,
  from: string,
  till: string,
): Promise<SrikandiSale> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const getSrikandiChildrenSales = httpsCallable(functions, 'query-srikandiChildrenSales');
  console.log(id, from, till);
  const { data } = await getSrikandiChildrenSales({ id, from, till });
  return data as SrikandiSale;
};

export const getSrikandiSummarySales = async (
  id: string,
  from: string,
  till: string,
): Promise<ISummarySale[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const srikandiSaleSummary = httpsCallable(functions, 'query-srikandiSaleSummary');
  console.log(id, from, till);
  const { data } = await srikandiSaleSummary({ id, from, till });
  return data as any;
};

export const getSalesReport = async (from: string, till: string): Promise<[]> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const saleSummaryReport = httpsCallable(functions, 'query-saleSummaryReport');
  console.log(from, till);
  const { data } = await saleSummaryReport({ from, till });
  return data as any;
};

// export const getSrikandiCommissions = async (
//   id: string,
//   date: string,
// ): Promise<ICommissionResponse> => {
//   const functions = getFunctions(firebaseApp, 'asia-southeast1');
//   useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
//   const srikandiCommissions = httpsCallable(functions, 'query-srikandiCommissions');
//   const { data } = await srikandiCommissions({ id, date });
//   return data as any;
// };
export const getSrikandiCommissions = async (
  id: string,
  date: string,
): Promise<ICommissionResponse> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  if (useEmulator) {
    return {} as any;
  }

  const response = await fetch(`${erpConfig.apiUrl}/srikandi/commissions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      AppKey: erpConfig.appKey,
      AppToken: erpConfig.appToken,
    },
    body: JSON.stringify({
      id: id,
      date: date,
    }),
  });
  const result = await response.json();
  if (!response.ok || result.error) {
    throw new Error(result.message || 'Failed to get commissions');
  }
  return result.data;
};
export const downloadSrikandiData = async (
  id: string,
): Promise<any> => {
  const functions = getFunctions(firebaseApp, 'asia-southeast1');
  useEmulator && connectFunctionsEmulator(functions, 'localhost', 5001);
  const downloadSrikandiData = httpsCallable(functions, 'query-downloadSrikandiData');
  const { data } = await downloadSrikandiData({ id });
  return data as any;
};

export const useSrikandiUser = (userId: string | undefined) => {
  const [user, setUser] = useState<IUser | null>(null);

  useEffect(() => {
    if (!userId) {
      return;
    }
    const database = getDatabase(firebaseApp);
    const userRef = ref(database, `users/${userId}`);
    get(userRef).then((userSnapshot) => {
      setUser({
        id: userSnapshot.key,
        ...userSnapshot.val(),
      });
    });
    return onValue(userRef, (userSnapshot) => {
      setUser({
        id: userSnapshot.key,
        ...userSnapshot.val(),
      });
    });
  }, [userId]);
  return user;
};
